export default function StatsSection() {
  const stats = [
    { num: '200+', label: '承办赛事', icon: 'ri-trophy-line', desc: '累计成功承办各类体育赛事' },
    { num: '50+', label: '专业教练', icon: 'ri-user-star-line', desc: '持证上岗的资深教练团队' },
    { num: '10万+', label: '服务用户', icon: 'ri-team-line', desc: '覆盖全国多个城市和地区' },
    { num: '100+', label: '合作场馆', icon: 'ri-building-line', desc: '优质场馆战略合作伙伴' },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-foreground-50">
      <div className="w-full px-6 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${stat.icon} text-primary-600 text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">
                {stat.num}
              </div>
              <div className="text-sm font-semibold text-foreground-700 mb-1">{stat.label}</div>
              <div className="text-xs text-foreground-500">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}